<template>
<div  v-if="resp.detail">
    <div class="head">
        <div v-if="resp.detail.authorInfo" class="avatarWrap marginL30" @click="goManager()">
            <img :src=" resp && resp.detail&&resp.detail.authorInfo&& resp.detail.authorInfo.headPic? resp.detail.authorInfo.headPic : ''" class="avatar" alt="" />
            <img src="../../static/ic_v_log.png" class="log" alt="">
        </div>
        <div v-if="resp.detail.authorInfo" class="row1" @click="goManager()" >
            <div class="S8 T1">{{ resp && resp.detail ? resp.detail.authorInfo.name : "" }}</div>
            <div class="S4 T3">{{ getDesc }}</div>
        </div>
        <div v-if="resp.detail.authorInfo" class="follow S5 C5" :class="resp.detail && resp.detail.authorInfo && resp.detail.authorInfo.isFollowed === 1 ?'followed':''" @click="follow()">
            <span>{{
            resp.detail && resp.detail.authorInfo && resp.detail.authorInfo.isFollowed === 1 ? '已关注' : '+关注'
          }}</span>
        </div>
    </div>
    <div v-if="resp.detail.authorInfo" class="S7 T2 desc">
        {{ resp.detail && resp.detail.authorInfo ? resp.detail.authorInfo.remark : "" }}
    </div>
    <div class="marginL30 S8 T1 ckjsTitle">课程介绍</div>
    <div class="S7 T2 ckjs">
        {{ resp.detail && resp.detail.detail ? resp.detail.detail.description : "" }}
    </div>
    <div class="marginL30 S8 T1 ckjsTitle">订购须知</div>
    <div class="S7 T2 ckjs orderRemark" v-html="resp && resp.detail ? resp.detail.detail.orderRemark : ''">
    </div>
    <div class="B2 sep20" />

    <Comment
      :commentsInfo="commentsInfo"
      :showInput="true"
      :showPupInput="!showCommentDetail && !currentIndex"
      :currentIndex="currentIndex"
      :hasPermission="isPermission"
      @onReplyEvent="onReplyEvent"
    />
    <div class="bottom-risk B2">
        <div class="S4 T3"> 风险提示：本内容仅供投资参考，不作为投资建议，股市有风险，投资需谨慎。</div>
    </div>

</div>
</template>

<script>
import Comment from "@/views/comment/Comment";
import {
    mapActions,
    mapState
} from "vuex";
import util from '@/util/util'
import {
    isGuest
} from "@/api/appInfo";
import {
    hasPermission
} from '@/api/permission'

export default {
    name: "VideoDetail",
    components: {
        Comment
    },
    props: ['currentIndex', 'showCommentDetail'],
    methods: {
        ...mapActions('follow', ['requestfollow']),
        hasPermission,

        onReplyEvent(item) {
            this.$emit('onReplyEvent', item)
        },

        follow() {
            if (isGuest()) {
                util.go("ycstock://login")
                return
            }
            this.resp.detail.authorInfo.isFollowed = this.resp.detail.authorInfo.isFollowed ^ 1
            console.log(this.resp.detail.authorInfo.isFollowed)
            this.requestfollow({
                authorid: this.resp.detail.authorInfo.authorId,
                follow: this.resp.detail.authorInfo.isFollowed
            })
        },
        goManager() {
            util.go("ycstock://managerDetail?managerId=" + this.resp.detail.authorInfo.authorId)
        }
    },
    computed: {
        ...mapState('video', ['resp']),
        ...mapState('follow', ['followResp']),

        getDesc() {
            if (!(this.resp &&
                this.resp.detail &&
                this.resp.detail.authorInfo)) {
                return ""
            }
            let authInfo = this.resp.detail.authorInfo
            let desc = authInfo.typeName
            if (authInfo.authorCompany) {
                desc += ' | ' + authInfo.authorCompany
            }
            return desc
        },

        isPermission() {
            return this.hasPermission(this.resp.detail.detail.productId)
        },

        commentsInfo() {
            if (!this.resp.detail) {
                return null;
            }
            return this.resp.detail.commentsInfo
        },
    },

    mounted() {}
}
</script>

<style scoped>
.head {
    align-items: center;
    display: flex;
    flex-direction: row;
    margin-top: 50px;
}

.head .row1 {
    margin-left: 30px;
}

.avatarWrap {
    height: 70px;
    width: 70px;
    position: relative;
}

.avatar {
    border-radius: 35px;
    height: 70px;
    width: 70px;
}

.log {
    position: absolute;
    width: 28px;
    height: 28px;
    right: 0;
    bottom: 0;
}

.marginL30 {
    margin-left: 30px;
}

.follow {
    display: flex;
    justify-content: center;
    right: 30px;
    width: 118px;
    position: absolute;
    height: 52px;
    border-radius: 5px;
    border-width: 2px;
    text-align: center;
    border-style: solid;
    border-color: #046bcc;
    align-items: center;
}

.followed {
    border-color: #858585 !important;
    color: #858585 !important;
}

.desc {
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 32px;
    word-wrap: break-word;
}

.ckjsTitle {
    margin-top: 60px;
    margin-bottom: 30px;
}

.ckjs {
    margin-top: 30px;
    margin-left: 30px;
    margin-right: 30px;
    word-wrap: break-word;
    line-height: 44px;
}

.sep20 {
    height: 20px;
}

.orderRemark {
    margin-bottom: 60px;
}

.bottom-risk {
    margin-top: 30px;
    padding: 30px;
}
</style>
